import { EsbForm as EsbForm } from 'src/app/services/dtos/esbForm';

export class FetchAllRegionsBasicInfo {
  public static readonly type = '[Regions] Fetch All Basic Infos';
}

export class FetchRegion {
  public static readonly type = '[Regions] Fetch Single';
  public constructor(public id: string) { }
}

export class AddRegion {
  public static readonly type = '[Regions] Add';
  public constructor(public code: string, public name: string) { }
}

export class UpdateRegion {
  public static readonly type = '[Regions] Update';
  public constructor(public id: string, public code: string, public name: string) { }
}

export class ClearCurrentRegionId {
  public static readonly type = '[Regions] Clear Current Region Id';
}

export class DeleteRegion {
  public static readonly type = '[Regions] Delete';
  public constructor(public id: string) { }
}

export class SetCurrentRegionId {
  public static readonly type = '[Regions] Set Current Laboratory Id';
  public constructor(public id: string) { }
}

export class DeleteRegionEsb {
  public static readonly type = '[Regions] Delete eESB';
  public constructor(public regionId: string, public esbId: string) { }
}

export class UpdateRegionEsb {
  public static readonly type = '[Regions] Update eESB';
  public constructor(public payload: EsbForm) { }
}

export class AddRegionEsb {
  public static readonly type = '[Regions] Add eESB';
  public constructor(public payload: EsbForm) { }
}
